// extracted by mini-css-extract-plugin
export default {"customDivider":"custom-divider_customDivider__EqsFw"};